import React from 'react';
import type { FormState } from '@types';
import { showAppAlert } from '../common/appDialog';
import { missingS04Intake } from '../../functions/src/common/s04Workflow';
import { ICONS } from './constants';
import EventSecurityFields from './EventSecurityFields';

interface EventSecurityPlannerFormProps {
    formData: FormState;
    onFormChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> | { target: { name: string; value: any } }) => void;
    onSubmit: (event: React.FormEvent) => void;
    isLoading: boolean;
    onRequestHelp?: () => void;
}

const EventSecurityPlannerForm: React.FC<EventSecurityPlannerFormProps> = ({ formData, onFormChange, onSubmit, isLoading, onRequestHelp }) => {
    const submit = (event: React.FormEvent) => {
        event.preventDefault();
        const missing = missingS04Intake(formData);
        if (missing.length) {
            void showAppAlert(`Complete these required fields: ${missing.join(', ')}.`);
            return;
        }
        onSubmit(event);
    };
    return <form onSubmit={submit} className="space-y-6 rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
    <div className="flex items-start justify-between gap-4 border-b pb-4"><div><h2 className="flex items-center gap-2 text-xl font-bold text-slate-800">
        {ICONS.shield} Event Security Plan</h2><p className="mt-1 text-sm text-slate-500">Build the SRM-04 threat assessment, deployment plan, report, and dashboard.</p></div>
        {onRequestHelp && <button type="button" onClick={onRequestHelp} className="flex items-center gap-2 rounded-full bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-600 hover:text-blue-800">{ICONS.help} Need Help?</button>}</div>
    <EventSecurityFields formData={formData} onFormChange={onFormChange} />
    <div className="flex justify-end border-t pt-6"><button type="submit" disabled={isLoading}
        className="flex min-w-[200px] items-center justify-center rounded-lg bg-blue-600 px-8 py-3 font-bold text-white shadow-md hover:bg-blue-700 disabled:opacity-50">
        {isLoading ? <span className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent" /> : 'Generate Security Plan'}</button></div>
</form>;
};

export default EventSecurityPlannerForm;
